import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API_BASE, formatApiError } from "./AuthContext";
import { ShieldCheck, Send, Flag, Loader2 } from "lucide-react";

export default function IdCheckBulkBar({ selected, visibleIds, onSelectAll, onDone }) {
  const [busy, setBusy] = useState(null);
  const run = async (action) => {
    if (action === "send" && !window.confirm(`Email an ID verification link to ${selected.length} client(s)?`)) return;
    setBusy(action);
    try {
      const { data } = await axios.post(`${API_BASE}/voi/bulk`, { client_ids: selected, action });
      if (action === "send") {
        const parts = [`${data.sent} sent`];
        if (data.skipped_open) parts.push(`${data.skipped_open} already have an open check`);
        if (data.skipped_verified) parts.push(`${data.skipped_verified} already verified`);
        if (data.failed.length) parts.push(`${data.failed.length} couldn't be emailed — copy their link from the ID check tab`);
        (data.failed.length ? toast.warning : toast.success)(`ID checks: ${parts.join(" · ")}`);
      } else {
        toast.success(action === "require"
          ? `${data.updated} client(s) flagged — staff will be warned when starting a job`
          : `${data.updated} client(s) unflagged`);
      }
      onDone();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(null); }
  };
  return (
    <div className="flex flex-wrap items-center gap-3 px-4 py-3 border-b border-[var(--border)] bg-[var(--subtle)]" data-testid="id-check-bulk-bar">
      <ShieldCheck size={15} className="text-[var(--ink-2)]" />
      <span className="text-[12px] text-[var(--ink-2)]" data-testid="id-check-selected-count">
        {selected.length} selected · showing clients not yet ID verified
      </span>
      <button className="text-[11px] text-[var(--accent)] hover:underline" onClick={() => onSelectAll(visibleIds)} data-testid="id-check-select-all">
        Select all {visibleIds.length}
      </button>
      <div className="flex-1" />
      <button className="btn-ghost" disabled={!selected.length || !!busy} onClick={() => run("require")} data-testid="id-check-flag">
        {busy === "require" ? <Loader2 size={13} className="animate-spin" /> : <Flag size={13} />} Warn on next job
      </button>
      <button className="btn-ghost" disabled={!selected.length || !!busy} onClick={() => run("unrequire")} data-testid="id-check-unflag">
        Remove flag
      </button>
      <button className="btn-primary" disabled={!selected.length || !!busy} onClick={() => run("send")} data-testid="id-check-send">
        {busy === "send" ? <Loader2 size={13} className="animate-spin" /> : <Send size={13} />} Send ID check
      </button>
    </div>
  );
}
